var exports = {
  "zr": "x1cb7f6e3--6966c6--root",
  "KX": "x1cb7f6e3--6966c6--text-content",
  "Kk": "x1cb7f6e3--6966c6--icon",
};

module.exports = exports;
